import React from 'react';
import ReactHtmlParser from 'html-react-parser';
import { useLang } from '@src/context';

const Text = ({ t }) => {
  const { dictionary } = useLang();
  const textToParse = dictionary[t] || t;

  // Değerin string olup olmadığını kontrol eder
  return <>{typeof textToParse === 'string' ? ReactHtmlParser(textToParse) : textToParse}</>;
};

export const useText = (t) => {
  const { dictionary } = useLang();
  return dictionary[t] || t;
};

export default Text;
